const driveMap = {
  namespaced: true,
  state: {
		popup: { error: '', date: '', speed: '' },
		event_data: { speed: 0, bat: 0, gear: '', seq: 0, heater: 0, aircon: 0, intemp: null, outtemp: null }
  },
  getters: {
  },
  mutations: {
    MUT_POPUP: (state, payload) => {
      state.popup = payload;
    },
    MUT_EVENT_DATA: (state, payload) => {
      state.event_data = payload;
    }
  },
  actions: {
  }
}

export default driveMap
